import consumer from './consumer';
import {
  embedSignature,
  onSignliftEvent,
  finalizeSignature,
  SIGNLIFT_EVENTS,
} from '../lib/signlift';

document.addEventListener('DOMContentLoaded', () => {
  const FINALIZE_RETRY_DELAY = 10000;
  const FINALIZE_MAX_ATTEMPTS = 6;

  const byId = (id) => document.getElementById(id);
  const selectAll = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  let iframe;
  let stopListening;
  let finalizeAttempts = 0;
  let reloading = false;

  function showErrorStep() {
    byId('subscriptionStep2')?.classList.add('d-none');
    byId('subscriptionStep3')?.classList.add('d-none');
    byId('subscriptionStep4')?.classList.add('d-none');
    byId('subscriptionStepError')?.classList.remove('d-none');
  }

  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof iframe == 'object')) {
      consumer.disconnect();
      showErrorStep();
    }
  }

  function reloadOnce() {
    if (reloading) return;

    reloading = true;
    window.location.reload();
  }

  function finalizeUrl() {
    return byId('subscriptionStep3')?.dataset?.signliftFinalizeUrl;
  }

  function finalize() {
    const url = finalizeUrl();
    if (!url) return;

    finalizeAttempts += 1;

    finalizeSignature(url)
      .then((response) => (response && response.ok ? response.json().catch(() => null) : null))
      .then((payload) => {
        if (payload && (payload.action === 'finalized' || payload.action === 'already_signed')) {
          reloadOnce();
        } else {
          retryFinalizeLater();
        }
      });
  }

  function retryFinalizeLater() {
    if (finalizeAttempts >= FINALIZE_MAX_ATTEMPTS) return;

    setTimeout(finalize, FINALIZE_RETRY_DELAY);
  }

  function generateSignliftIframe(signingUrl) {
    iframe = embedSignature(byId('subscriptionStep3'), signingUrl);
    if (iframe) {
      iframe.title = 'Signature électronique';
      iframe.referrerPolicy = 'origin';
      iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms');
    }

    stopListening?.();
    stopListening = onSignliftEvent(
      ({ type }) => {
        if (type === SIGNLIFT_EVENTS.SUCCESS) {
          finalize();
        } else if (type === SIGNLIFT_EVENTS.ERROR) {
          showErrorStep();
        }
      },
      signingUrl,
      iframe,
    );
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '86%';
    iframe.src = documentUrl;

    byId('subscriptionStep3')?.prepend(iframe);

    selectAll('.edit_subscription').forEach((el) => {
      el.addEventListener('ajax:success', (_event) => {
        byId('subscriptionStep3')?.classList.add('d-none');
        byId('subscriptionStep4')?.classList.remove('d-none');

        const breadcrumb3 = document.querySelector('.breadcrumb-element:nth-child(3)');
        breadcrumb3?.classList.remove('current');
        breadcrumb3?.classList.add('past');

        const breadcrumb4 = document.querySelector('.breadcrumb-element:nth-child(4)');
        breadcrumb4?.classList.remove('next');
        breadcrumb4?.classList.add('current');

        const currentStep = byId('current_step');
        if (currentStep) currentStep.textContent = '4';
      });
    });
  }

  function announceContractReady() {
    // Enable the button to load the contract and display the success message
    const contractLoadedButton = byId('contractLoadedButton');
    if (contractLoadedButton) contractLoadedButton.disabled = false;

    const subscriptionStep2 = byId('subscriptionStep2');
    const stepTitle = byId('step-title');
    if (subscriptionStep2 && stepTitle) {
      stepTitle.textContent = subscriptionStep2.dataset.titleInCaseOfDocReady;
    }

    selectAll('#subscriptionStep2 [data-image-before-doc-ready]').forEach((el) => el.classList.add('d-none'));
    selectAll('#subscriptionStep2 [data-image-in-case-of-doc-ready]').forEach((el) => {
      el.classList.add('d-flex');
      el.classList.remove('d-none');
    });
    byId('generatingDocInProgressExplanations')?.classList.add('d-none');
    byId('generatingDocReadyExplanations')?.classList.remove('d-none');

    contractLoadedButton?.addEventListener('click', (_e) => {
      byId('subscriptionStep3')?.classList.remove('d-none');
      byId('subscriptionStep2')?.classList.add('d-none');

      const breadcrumb2 = document.querySelector('.breadcrumb-element:nth-child(2)');
      breadcrumb2?.classList.remove('current');
      breadcrumb2?.classList.add('past');

      const breadcrumb3 = document.querySelector('.breadcrumb-element:nth-child(3)');
      breadcrumb3?.classList.remove('next');
      breadcrumb3?.classList.add('current');

      const currentStep = byId('current_step');
      if (currentStep) currentStep.textContent = '3';
    });
  }

  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  const signatureSubscriptionEl = byId('signature-subscription-id');
  if (!signatureSubscriptionEl) {
    return;
  }

  consumer.subscriptions.create(
    { channel: 'SignatureChannel', subscription_id: signatureSubscriptionEl.dataset.id },
    {
      received(data) {
        try {
          if (data.status == 'signed') {
            clearTimeout(docliftDoesNotAnswerTimer);
            reloadOnce();
            return;
          }

          if (data.status == 'awaiting_finalization') {
            clearTimeout(docliftDoesNotAnswerTimer);
            retryFinalizeLater();
            return;
          }

          if (data.status == 'success') {
            clearTimeout(docliftDoesNotAnswerTimer);

            if (data.signing_url !== undefined) {
              generateSignliftIframe(data.signing_url);
            } else {
              generateContractIframe(data.document_url);
            }

            announceContractReady();
          } else {
            setTimeout(showErrorStep, 5000);
          }
        } catch {
          setTimeout(showErrorStep, 5000);
        }
      },
      rejected() {
        setTimeout(showErrorStep, 5000);
        this.uninstall();
      },
    },
  );
});
